module.exports = __webpack_public_path__ + "img/SOKAL-SRS-120921-Tucson-Established.20bec665.jpeg";